window.ontabclose = {};

export interface CloseTabEvent {
  prevent: boolean;
}

export const onCloseTab = function(callback: (event: CloseTabEvent) => any) {
  const { currentRoute } = useRouter();

  window.ontabclose[currentRoute.value.fullPath] = callback;
}


type Notification = {
  type: "SUCCESS"|"WARNING"|"ERROR"|"INFO";
  title: string;
  message: string|null;
}
export function onNotification(callback: (notification: Notification) => void) {
  const onNotif = (event: Event) => {
    if (!(event instanceof CustomEvent)) return;

    const notification = event.detail as Notification;

    callback(notification);
  };
  window.addEventListener("food:notification", onNotif)

  return () => {
    window.removeEventListener("food:notification", onNotif);
  };
}
